import { FC, ReactElement } from 'react'
import styled from 'styled-components'

const Gauge: FC<{ value?: number }> = ({ value }): ReactElement => {
  const hasValue = value !== undefined && !isNaN(value)
  return (
    <MasterWrapper>
      <Resizer>
        <GaugeWrapper>
          <Scale>
            <Background hasValue={hasValue}>
              <Hole hasValue={hasValue} />
            </Background>
          </Scale>
          <NeedleWrapper
            className='needle-wrapper'
            style={{
              transformOrigin: 'bottom',
              transform: value
                ? 'rotate(' + (180 * (value * 0.01) - 90) + 'deg)'
                : '',
            }}
          >
            <Needle
              version='1.1'
              className='needle'
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              x='0px'
              y='0px'
              width='100%'
              height='auto'
              viewBox='0 0 436 249'
              xmlSpace='preserve'
              fill='currentColor'
              opacity={hasValue ? 1 : 0}
            >
              <g>
                <path
                  className='st0'
                  d='M211.5759,219.7792c-7.6403,3.7388-10.7289,13.0047-6.99,20.6449s13.0047,10.7289,20.6449,6.99
        c7.6403-3.7388,10.7289-13.0047,6.99-20.6449C228.3194,219.129,219.2161,216.0403,211.5759,219.7792z M221.4919,240.099
        c-3.5763,1.7881-7.9654,0.3251-9.7535-3.4137c-1.7881-3.5763-0.3251-7.9654,3.4137-9.7535
        c3.7388-1.7881,7.9654-0.3251,9.7535,3.4137C226.6938,233.9218,225.2308,238.3109,221.4919,240.099z'
                />
                <path
                  className='st0'
                  d='M225.2705,219.7792L218.2805,0l-6.5023,219.7792C216.1673,217.6659,221.2066,217.8285,225.2705,219.7792
        L225.2705,219.7792z'
                />
              </g>
            </Needle>
          </NeedleWrapper>
        </GaugeWrapper>
      </Resizer>
    </MasterWrapper>
  )
}
const MasterWrapper = styled.div`
  aspect-ratio: 2 / 1;
  max-width: 100%;
`
const Resizer = styled.div`
  max-height: 50%;
`
const GaugeWrapper = styled.div`
  transform: translateY(-50%);
  display: grid;
  aspect-ratio: 1/1;
`
const Background = styled.div<{ hasValue?: boolean }>`
  background: conic-gradient(
    // from 270deg at 50% 50%,
    // #ffa56d -1deg,
    // #d3343f 181deg
    from 270deg at 50% 50%,
    #479260 0deg ,
    #ffc800  45deg,
    #e16d00 90deg,
    #d3343f 135deg,
    #691a1f 180deg
  );
  opacity: ${({ hasValue }) => (hasValue ? `1` : '0.3')};
  border-radius: 50% 50% 0 0;
  width: 100%;
  height: 100%;
  transform: translateY(50%);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease;
  /* animation: fadein 0.3s ease-in-out;
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  } */
`
const Scale = styled.div`
  grid-column: 1;
  grid-row: 1;
  height: 100%;
  overflow: hidden;
  /* display: flex; */
`
const Hole = styled.div<{ hasValue?: boolean }>`
  background: var(--site-background);
  border-radius: 50%;
  width: 75%;
  height: 75%;
  /* ${({ hasValue }) => (hasValue ? `` : 'scale: 1.1;')}
  transition: all 0.5s ease; */
  /* animation: scaleIn 1s ease;
  @keyframes scaleIn {
    from {
      transform: scale(1.02);
    }
    to {
      transform: scale(1);
    }
  } */
`
const NeedleWrapper = styled.div`
  grid-column: 1;
  grid-row: 1;
  display: flex;
  transition: all 1s cubic-bezier(0.315, 1.65, 0.685, 0.91);
  transform: rotate(-90deg);
  /* for teaser animation */
  /* animation: needle 2s ease-in-out alternate infinite;
  @keyframes needle {
    0% {
      transform: rotate(-45deg);
    }
    100% {
      transform: rotate(45deg);

    }
  } */
`
const Needle = styled.svg`
  transform: translateY(25%);
  transition: all 0.5s ease;
`
export default Gauge
